import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const TabPane = memo(({ active, id, tabId, children, classes }) => {
    const className = classnames(classes.tabPane, {
        [classes.tabPaneInactive]: !active,
    });

    return (
        <div
            className={className}
            role="tabpanel"
            id={id}
            aria-labelledby={tabId}
            aria-hidden={!active}
            style={{ display: active ? 'block' : 'none' }}
        >
            {children}
        </div>
    );
});

TabPane.propTypes = {
    /** Whether this tab pane is currently visible */
    active: PropTypes.bool,
    /** Unique ID for the panel element */
    id: PropTypes.string.isRequired,
    /** ID of the associated tab button for accessibility */
    tabId: PropTypes.string.isRequired,
    /** Content to display inside the tab pane */
    children: PropTypes.node,
    /** Classes object provided by the styling system */
    classes: PropTypes.object,
};

export default TabPane;
